// extracted by mini-css-extract-plugin
export default {"TemperatureWrapper":"Temperature_TemperatureWrapper__p2mIr","TemperatureSymbol":"Temperature_TemperatureSymbol__11XTk"};